import { connect } from 'react-redux';
import Miscellaneous from '../../components/metadata/miscellaneous';

const mapStateToProps = function(state) {
	return {
		owner: state.media.item.creator,
		datetimeCreated: state.media.item.datetime_created,
		datetimeLastModified: state.media.item.datetime_last_modified,
		duration: state.player.duration || null,
		size: state.media.item.size || null,
		views: state.stats === undefined || state.stats.views === undefined ? null : state.stats.views,
		copyright: state.media.copyright ? state.media.copyright.title : null
	};
}

const mapDispatchToProps = function(dispatch) {
	return {};
}

const MiscellaneousContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Miscellaneous)

export default MiscellaneousContainer;